import { BookingResponse } from '@shared/bookings';
import { CustomerResponse as OriginalCustomerResponse } from '@shared/customers';
import { ParentResponse } from '@shared/parents';
import {
  AddressResponse,
  PhoneResponse,
  SchemaResponseFields,
} from '@shared/util';

export const eventBookingTypes = [
  'wedding',
  'conference',
  'schoolHoliday',
  'corporate',
  'sports',
  'creche',
  'other',
] as const;

export type EventBookingType = (typeof eventBookingTypes)[number];

export const eventBookingTypeTitles = new Map<EventBookingType, string>([
  ['wedding', 'Wedding'],
  ['conference', 'Conference'],
  ['schoolHoliday', 'School Holiday Kids Club'],
  ['corporate', 'Corporate Kids Club'],
  ['sports', 'Sporting Event'],
  ['creche', 'Créche'],
  ['other', 'Other'],
]);

export const eventBookingStatuses = [
  'unpublished',
  'published',
  'cancelled',
] as const;

export type EventBookingStatus = (typeof eventBookingStatuses)[number];

export const eventBookingStatusTitles = new Map<EventBookingStatus, string>([
  ['unpublished', 'Unpublished'],
  ['published', 'Published'],
  ['cancelled', 'Cancelled'],
]);

export const eventBookingStatusColors = new Map<EventBookingStatus, string>([
  ['unpublished', 'warning'],
  ['published', 'secondary'],
  ['cancelled', 'danger'],
]);

export class BookingDateTimeResponse {
  _id: string;
  date: string;
  startTime: string;
  endTime: string;
  numChildren: string;
}

export type CustomerResponse = Omit<OriginalCustomerResponse, 'parents'> & {
  parents: ParentResponse[];
};

export class EventBookingResponse extends SchemaResponseFields {
  eventType: EventBookingType;
  eventTypeDetails: string;
  eventContactName: string;
  eventContactPhone: PhoneResponse;
  eventContactEmail: string;
  weddingCoordinatorName: string;
  weddingCoordinatorPhone: PhoneResponse;
  address?: AddressResponse;
  addressNotes: string;
  childrenAges: string;
  childrenOutOfNappies: 0 | 1;
  // freeParkingAvailable: boolean;
  // parkingDetails: string;
  otherDetails: string;
  customer: CustomerResponse | undefined;
  bookingDateTime: BookingDateTimeResponse[];
  bookings: BookingResponse[]; // Populated when booking is published
  publishDetails?: PublishEventBookingDetailsResponse;

  // publishedBookingGroups allows the grouping of the published bookings
  publishedBookingGroups: Array<string[]>;

  status: EventBookingStatus;
}

export class PublishBookingPricingResponse {
  title: string;
  unit: string;
  quantity: string;
  customerCharge: string;
  sitterPayment: string;
}

export class DayOfEventResponse {
  bookingDateId: string;
  eventDatePricings: Array<PublishBookingPricingResponse>;
  travelFeeIncluded: boolean;
}

export class EventBookingCarerResponse {
  tags: string[];
  role?: string;
  selectedSitterId?: string;
  selectedSitterName?: string;
  daysOfEvent: DayOfEventResponse[];
}

export class PublishEventBookingDetailsResponse {
  bookingId: string;
  eventBookingCarers: Array<EventBookingCarerResponse>;
  parentId?: string;
}

export class EditPublishEventBookingResponse {
  eventBooking: EventBookingResponse;
  editPublishBooking: PublishEventBookingDetailsResponse;
}
